import { parsePhoneNumberFromString } from "libphonenumber-js";
const { createLocation } = require("./addressValidation");

const yup = require("yup");
const createAccountValidationSchema = () => {
  return updateAccountValidationSchema
    .concat(
      yup.object({
        user: yup.object().shape({
          firstName: yup
            .string()
            .matches(
              /^[A-Za-z ]*$/,
              "First Name can only contain alphabetic characters and spaces",
            )
            .required("First Name is required"),
          lastName: yup
            .string()
            .matches(
              /^[A-Za-z ]*$/,
              "Last Name can only contain alphabetic characters and spaces",
            )
            .required("Last Name is required"),
          email: yup
            .string()
            .email("Email Address is not valid")
            .required("Email Address is required"),
          phone: yup
            .string()
            .test(
              "isPhoneValid",
              "Phone Number is not valid",
              (phoneNumber) => {
                if (!phoneNumber) return false;
                const parsedPhoneNumber = parsePhoneNumberFromString(
                  phoneNumber,
                  "US",
                );
                return parsedPhoneNumber ? parsedPhoneNumber.isValid() : false;
              },
            )
            .required("Phone Number is required"),
          address: createLocation,
          employeeGroup: yup.string(),
          role: yup.string().required("Role is required"),
          status: yup.string(),
        }),
      }),
    )
    .test(
      "nameLength",
      "First Name and Last Name together should not exceed 24 characters. This will be printed on the card.",
      function (values) {
        const { firstName, lastName } = values.user;
        return (firstName?.length || 0) + (lastName?.length || 0) <= 24;
      },
    );
};

const updateAccountValidationSchema = yup.object().shape({
  account: yup.object().shape({
    businessLegalName: yup
      .string()
      .required("Account name/Business Legal Name is required"),
    description: yup.string(),
    businessDBA: yup.string(),
    businessCardName: yup.string(),
    businessEmail: yup.string(), // Not required
    phoneNumber: yup.string(), // Not required
    websiteURL: yup.string(), // Not required
  }),
});

const requestBulkEnrollmentSchema = yup.object().shape({
  network: yup.string().required("Network is required"),
  networkReference: yup.string().required("Network reference is required"),
  networkName: yup.string().required("Network name is required"),
});
export {
  createAccountValidationSchema,
  updateAccountValidationSchema,
  requestBulkEnrollmentSchema,
};
